import { render, staticRenderFns } from "./Portofolio.vue?vue&type=template&id=02a2b878&scoped=true&"
import script from "./Portofolio.vue?vue&type=script&lang=js&"
export * from "./Portofolio.vue?vue&type=script&lang=js&"
import style0 from "./Portofolio.vue?vue&type=style&index=0&id=02a2b878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a2b878",
  null
  
)

export default component.exports